import React from "react";
import Banner from "../../Common/Banner";
import img1 from "../../../Assets/Images/img-whatis-banner@3x.png";
import CSService from "./CSService";
import QAService from "./QAService";
import MarketingService from "./MarketingService";
import MornitoringService from "./MornitoringService";
import { useNavigate } from "react-router-dom";
import { RoutesString } from "../../Modules/routesString";
import * as Scroll from "react-scroll"
function IntroPage() {
  const navigation = useNavigate();
  const scroll = Scroll.animateScroll
  return (
    <main>
      <Banner
        img={img1}
        title={`ADD-UP服務的新名詞, \n CSbye`}
        subTitle="客戶滿意的服務， CSbye的開始"
        detail={`'CSbye'是現有APP-UP服務CS, QA, 營銷和監控服務的統稱。\n可以在一個地方解決現有服務的APP-UP服務的新名稱。`}
        onPressButton={() => {
          scroll.scrollToTop()
          navigation(RoutesString.Customer_tw);
         
        }}
        textButton={"服務諮詢"}
        backgroundColor="#63aeff"
      />
      <CSService />
      <QAService />
      <MarketingService />
      <MornitoringService />
    </main>
  );
}

export default IntroPage;
